import { render, staticRenderFns } from "./registrationSettings.vue?vue&type=template&id=acef30d0&scoped=true&"
import script from "./registrationSettings.vue?vue&type=script&lang=js&"
export * from "./registrationSettings.vue?vue&type=script&lang=js&"
import style0 from "./registrationSettings.vue?vue&type=style&index=0&id=acef30d0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acef30d0",
  null
  
)

export default component.exports